var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOrderNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.02148,
    r: 6,
    fill: "#FA1C44"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.02148,
    r: 5.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.075 8.59648H8H6.95222H6.90857L6.88701 8.55852L4.78396 4.8558C4.78484 4.87849 4.78571 4.90146 4.78659 4.92471C4.7954 5.03741 4.80201 5.15467 4.80642 5.27647M8.075 8.59648L4.73147 5.27919M8.075 8.59648V8.52148V3.52148V3.44648H8H7.23558H7.16058V3.52148V6.0635H7.16053L7.16064 6.06644C7.16503 6.1784 7.16942 6.29504 7.17381 6.41635C7.17817 6.53687 7.18035 6.65501 7.18035 6.77078H7.1803L7.18041 6.77361L7.19359 7.11686L7.1936 7.11699C7.19399 7.12669 7.19439 7.13633 7.19479 7.14592M8.075 8.59648L7.27593 7.28819M4.80642 5.27647L4.73147 5.27919M4.80642 5.27647L4.80641 5.27637L4.73147 5.27919M4.80642 5.27647L4.8196 5.63362L4.83278 5.99776L4.83287 6.00048H4.83283V8.52148V8.59648H4.75783H4H3.925V8.52148V3.52148V3.44648H4H5.04119H5.08475L5.10633 3.48433L7.19479 7.14592M4.73147 5.27919L4.74465 5.63633L4.75783 6.00048V8.44648V8.52148H4.68283H4.075H4V8.44648V3.59648V3.52148H4.075H5.04119L7.20181 7.30961C7.19947 7.25703 7.19713 7.20246 7.19479 7.14592M7.19479 7.14592L7.27593 7.28819M7.27593 7.28819C7.27347 7.23231 7.271 7.17422 7.26853 7.11392L7.27593 7.28819Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrderNew);
export default __webpack_public_path__ + "static/media/ic_order_new.a123eaecd541fa3b1c5e35d231382af8.svg";
export { ForwardRef as ReactComponent };